import { Flex } from '@solinkcorp/solink-components';
import classNames from 'classnames';
import EventTimePickerDuration from 'components/EventTimePicker/EventTimePickerDuration';
import EventTimePickerRange from 'components/EventTimePicker/EventTimePickerRange';
import TimezoneNotice from 'components/TimezoneNotice/TimezoneNotice';
import useLocale from 'src/hooks/useLocale';
import * as DateHandler from 'utils/DateHandler';

interface DetailsFormTimePickerProps {
  timezoneId: string;
  startTime: Date | undefined;
  endTime: Date | undefined;
  durationLimitsMs?: readonly [number, number];
  disabled?: boolean;
  updateStartTime: (date: Date | undefined) => void;
  updateEndTime: (date: Date | undefined) => void;
  showSecond?: boolean;
  errorText?: string;
  blurDurationInMs: number;
  faceblur: boolean;
}

export default function DetailsFormTimePicker(props: DetailsFormTimePickerProps) {
  const {
    timezoneId,
    startTime,
    endTime,
    durationLimitsMs,
    disabled,
    updateEndTime,
    updateStartTime,
    showSecond,
    errorText,
    blurDurationInMs,
    faceblur,
  } = props;
  const locale = useLocale();

  return (
    <Flex flexDirection="column" gap="0.5rem" style={{ marginTop: '0.5rem' }}>
      <TimezoneNotice className="event-timepicker-timezone" timezoneId={timezoneId} />
      <Flex gap="0.5rem" alignItems="stretch" className="details-form-time-section">
        <Flex.Item flexBasis="66%" alignSelf="stretch">
          <EventTimePickerRange
            timezoneId={timezoneId}
            startTime={startTime}
            endTime={endTime}
            updateEndTime={updateEndTime}
            updateStartTime={updateStartTime}
            durationLimitsMs={durationLimitsMs}
            disabled={disabled}
            maxDate={new Date()}
          />
        </Flex.Item>
        <Flex.Item flexBasis="33%" alignSelf="stretch">
          <Flex
            flexDirection="column"
            height="100%"
            className={classNames('details-form-durations', { faceblur })}
          >
            <EventTimePickerDuration
              title={locale.faceblur.clipDuration}
              className="clip-duration"
              duration={
                startTime && endTime
                  ? DateHandler.getDuration(locale, startTime, endTime, { showSeconds: showSecond })
                  : 'N/A'
              }
            />
            {faceblur && (
              <EventTimePickerDuration
                title={locale.faceblur.blurDuration}
                className="blur-duration"
                infoTooltip={locale.faceblur.blurDurationInfo}
                duration={DateHandler.durationToString(locale, blurDurationInMs, {
                  showSeconds: showSecond,
                })}
              />
            )}
          </Flex>
        </Flex.Item>
      </Flex>
      {errorText && <div className="error-text">{errorText}</div>}
    </Flex>
  );
}
